import { each, filter } from 'lodash-es'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['shouldGiftRuleHaveSelection', 'giftRules']),
    shouldGiftChoiceBlockBeDisplayed () {
      let shouldBeDisplayed = false
      each(this.giftRules, (giftRule) => {
        if (this.shouldGiftRuleHaveSelection(giftRule.id)) {
          shouldBeDisplayed = true
        }
      })
      return shouldBeDisplayed
    }
  },
  methods: {
    filterGiftsWithChoice (giftRulesByGroupIds) {
      return filter(giftRulesByGroupIds, (giftRule) => {
        return this.shouldGiftRuleHaveSelection(giftRule.id)
      })
    }
  }
}
